export default "__VITE_PUBLIC_ASSET__127a5a17__"